<template>
  <!-- Lazy boundary around the logo registry: inline.vue eagerly globs all 565 airline SVGs into
       one ~2.6 MB chunk, and a static import would make hydration wait for its download and parse.
       Server-side the async component resolves before render (the SVGs stay inline in the HTML);
       client-side Vue keeps the server DOM in place and hydrates this subtree when the chunk lands. -->
  <LazyUiCustomAirlineLogoInline />
</template>
